module.exports = __webpack_public_path__ + "static/img/goodsList3.a340fc38.png";